export const tagList = [
    {
        id: 1,
        name:"Female"
    },
    {
        id: 2,
        name:"Veteran"
    },
    {
        id: 3,
        name:"Specially Abled"
    },
    {
        id: 5,
        name:"LGBTQI"
    },
    {
        id: 6,
        name:"Working Mother"
    }
]